<template>
  <div>
    <div class="page-header">
      <h1 slot="title" class="page-title">Credit Hire Organisations</h1>
      <a href="#" class="btn btn-primary" v-on:click.prevent="sendToCreateView"
        >Create CHO</a
      >
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <table class="table carpenter">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email Address</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-bind:key="index"
                v-for="(creditHireOrganisation,
                index) in creditHireOrganisations"
              >
                <td v-text="creditHireOrganisation.name"></td>
                <td v-text="creditHireOrganisation.email"></td>
                <td>
                  <router-link
                    :to="
                      `/credit-hire-organisations/${creditHireOrganisation.identifier}`
                    "
                    class="btn btn-primary btn-sm with-icon"
                    >Edit</router-link
                  >
                  <a
                    class="btn btn-danger btn-sm with-icon"
                    v-if="creditHireOrganisation.active"
                    href=""
                    v-on:click.prevent="deactivate(creditHireOrganisation)"
                    >Deactivate</a
                  >
                  <a
                    class="btn btn-success btn-sm with-icon"
                    v-else
                    href="#"
                    v-on:click.prevent="activate(creditHireOrganisation)"
                    >Activate</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination">
            <div class="btn-group" role="group">
              <button
                class="btn btn-primary btn-sm with-icon"
                type="button"
                :disabled="!prevPageUrl"
                v-on:click.prevent="previousPage"
              >
                <i class="material-icons">arrow_back</i>
                Back
              </button>
              <button
                class="btn btn-success btn-sm with-icon"
                type="button"
                :disabled="!nextPageUrl"
                v-on:click.prevent="nextPage"
              >
                <i class="material-icons">arrow_forward</i>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      creditHireOrganisations: [],
      nextPageUrl: null,
      prevPageUrl: null,
      currentPage: 1,
      loading: true
    };
  },

  mounted() {
    this.findCreditHireOrganisations('/credit-hire-organisations');
  },

  methods: {
    activate(creditHireOrganisation) {
      window.Ajax.patch(
        `/credit-hire-organisations/${creditHireOrganisation.identifier}/activate`
      )
        .then(response => {
          window.toastify.success(
            'Activated',
            'The credit hire organisation was activated successfully!'
          );
          creditHireOrganisation.active = 1;
        })
        .catch(err => {});
    },

    deactivate(creditHireOrganisation) {
      window.Ajax.patch(
        `/credit-hire-organisations/${creditHireOrganisation.identifier}/deactivate`
      )
        .then(response => {
          window.toastify.success(
            'Deactivated',
            'The credit hire organisation was deactivated successfully!'
          );
          creditHireOrganisation.active = 0;
        })
        .catch(err => {});
    },

    previousPage() {
      if (this.prevPageUrl) {
        this.findCreditHireOrganisations(
          `/credit-hire-organisations?page=${this.currentPage - 1}`
        );
      }
    },

    nextPage() {
      if (this.nextPageUrl) {
        this.findCreditHireOrganisations(
          `/credit-hire-organisations?page=${this.currentPage + 1}`
        );
      }
    },

    findCreditHireOrganisations(url) {
      this.loading = true;

      window.Ajax.get(url)
        .then(response => {
          this.loading = false;
          this.creditHireOrganisations = response.data.data;
          this.nextPageUrl = response.data.next_page_url;
          this.prevPageUrl = response.data.prev_page_url;
          this.currentPage = response.data.current_page;
        })
        .catch(err => {});
    },

    sendToCreateView() {
      this.route('/credit-hire-organisations/create');
    }
  }
};
</script>
